/* global window, document */

import React from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/browser'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import store, { history } from './store'
import App from './App'
import 'sanitize.css/sanitize.css'
import './index.css'

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    dsn: 'https://ca641fcbb23644e48ace58411afddd1b@sentry.io/1425211',
  })
}

const target = document.querySelector('#root')

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    if (window.location.hostname !== 'localhost') {
      Sentry.withScope((scope) => {
        Object.keys(errorInfo).forEach((key) => {
          scope.setExtra(key, errorInfo[key])
        })
        Sentry.captureException(error)
      })
    }
  }

  render() {
    const { error } = this.state
    const { children } = this.props
    if (error) {
      return (
        <button type="button" onClick={() => Sentry.showReportDialog()}>
          Report feedback
        </button>
      )
    }
    return children
  }
}

function initApp() {
  render(
    <ErrorBoundary>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div>
            <App />
          </div>
        </ConnectedRouter>
      </Provider>
    </ErrorBoundary>,
    target,
  )
}
store.firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    window.user = user

    store.firebase
      .ref(`/userProfiles/${user.uid}`)
      .once('value')
      .then((snapshot) => {
        const chatName = (snapshot.val() && snapshot.val().chatName) || 'Anonymous'
        // todo check condition !
        if (chatName === 'Anonymous') {
          store.firebase.ref(`/userProfiles/${user.uid}`).update({
            chatName: 'Anonymous',
          })
        }

        initApp()
      })
  } else {
    store.firebase
      .auth()
      .signInAnonymously()
      .then((user) => {
        window.user = user
        store.firebase.ref(`/userProfiles/${user.uid}`).update({
          isSet: true,
          phoneNumber: user.phoneNumber,
          chatName: 'Anonymous',
        })
        initApp()
      })
  }
})



// WEBPACK FOOTER //
// ./src/index.js